export default __webpack_public_path__ + "static/media/catalog-gestalt.e560dc25.svg";